import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-cr-form-field-tooltip',
  templateUrl: './cr-form-field-tooltip.component.html',
  styleUrls: ['./cr-form-field-tooltip.component.scss'],
  standalone: false,
})
export class CrFormFieldTooltipComponent {
  @Input() text!: string;
  @Input() icon?: string = 'info_outline';
  @Input() svgIcon?: string;
  @Input() ariaLabel?: string;
  @Input() disabled?: boolean = false;
  @Input() tooltipClass: string = 'cr-tooltip';
}
